'use strict';

var toastr = require('toastr');
var _ = require('lodash');
function FaresSurchargeUploadService(restangular, fileSaveService, $log, featureToggleService) {
  var saveService = restangular.service('domain').one('surcharge').one('override');
  function formatAsCsvRow(stringArayToFormat) {
    return stringArayToFormat.join(',') + '\r\n';
  }
  function existingRecord(entry) {
    return {
      marketOrigin: entry.origin,
      marketDestination: entry.destination,
      begin: entry.effectiveDate.toISOString(),
      end: entry.discontinueDate.toISOString(),
      fareClass: entry.className,
      spos: entry.spos ? entry.spos : 'Default',
      surcharge: entry.surcharge
    };
  }
  var header = ['ORIGIN', 'DESTINATION', 'EFFECTIVE DATE', 'DISCONTINUE DATE', 'CLASS', 'SURCHARGE'];
  function createCsvHeader() {
    if (featureToggleService.isEnabled('FIM') && featureToggleService.isEnabled('SPOS')) {
      header.splice(5, 0, 'POS');
    }
    return formatAsCsvRow(header);
  }
  function getRow(row) {
    var newRow = [row.origin, row.destination, row.effectiveDate.toISOString(), row.discontinueDate.toISOString(), row.className, row.surcharge];
    if (featureToggleService.isEnabled('FIM') && featureToggleService.isEnabled('SPOS')) {
      newRow.splice(5, 0, row.spos);
    }
    return newRow;
  }
  function createCsvRow(row) {
    return formatAsCsvRow(getRow(row));
  }
  function exportMarketClassSurcharges(gridId, data) {
    var fileData = createCsvHeader();
    for (var rowId = 0; rowId < data.length; rowId++) {
      fileData += createCsvRow(data[rowId]);
    }
    fileSaveService.createFile(fileData, 'text/csv', fileSaveService.createFileName(gridId, 'csv'));
  }
  function singleRowToJSON(entry) {
    return {
      newValue: existingRecord(entry)
    };
  }
  function createPreviousFareDateRangesValue(entry) {
    return {
      marketOrigin: entry.origin,
      marketDestination: entry.destination,
      begin: entry._old.effectiveDate ? entry._old.effectiveDate.toISOString() : entry.effectiveDate.toISOString(),
      end: entry._old.discontinueDate ? entry._old.discontinueDate.toISOString() : entry.discontinueDate.toISOString(),
      fareClass: entry.className,
      spos: entry.spos ? entry.spos : 'Default',
      surcharge: entry._old.surcharge || entry.surcharge
    };
  }
  function deleteRowToJSON(entry) {
    return {
      oldValue: existingRecord(entry)
    };
  }
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('ConfigurationMarketClassFareService: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
  }
  function saveConfigurationMarketClassSurcharges(selectedRows) {
    var faresToSave = {
      value: []
    };
    for (var i = 0; i < selectedRows.length; i++) {
      var singleFare = singleRowToJSON(selectedRows[i]);
      if (!selectedRows[i].isNewlyAdded && !_.has(selectedRows[0]._old, 'origin')) {
        singleFare.oldValue = createPreviousFareDateRangesValue(selectedRows[i]);
      }
      faresToSave.value.push(singleFare);
    }
    return saveService.customPUT(faresToSave).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  function removeMarketClassSurcharges(selectedRows) {
    var faresToDelete = {
      value: []
    };
    for (var i = 0; i < selectedRows.length; i++) {
      var singleFare = deleteRowToJSON(selectedRows[i]);
      faresToDelete.value.push(singleFare);
    }
    return saveService.customPUT(faresToDelete).then(postColumnsSuccessHandler, postColumnsErrorHandler);
  }
  return {
    saveConfigurationMarketClassSurcharges: saveConfigurationMarketClassSurcharges,
    removeMarketClassSurcharges: removeMarketClassSurcharges,
    exportMarketClassSurcharges: exportMarketClassSurcharges
  };
}
FaresSurchargeUploadService.$inject = ['Restangular', 'FileSaveService', '$log', 'FeatureToggleService'];
module.exports = FaresSurchargeUploadService;